/**
 * Memoized asset list item for value boxes.
 * Prevents re-renders when other assets change.
 */
import { memo } from "react";

export interface AssetListItemProps {
  id: string;
  name: string;
  iconPath?: string;
}

export const AssetListItem = memo<AssetListItemProps>(({ name, iconPath }) => (
  <div className="flex items-center gap-2 text-[10px]">
    {iconPath && <img src={iconPath} alt={name} className="h-4 w-4 rounded" />}
    <span className="text-sa-text">{name}</span>
  </div>
));

AssetListItem.displayName = "AssetListItem";
